<div class="has-feedback">
    <input [(ngModel)]="companyName"
           [wsTypeahead]="dataSource"
           placeholder="Choose Company"
           (typeaheadLoading)="companiesLoading = $event"
           class="form-control"
           typeaheadOptionField="companyName"
           [typeaheadOptionsLimit]="1000"
           (typeaheadOnSelect)="typeaheadOnSelect($event)"
           [typeaheadMinLength]="2"
           [typeaheadWaitMs]="500"
           (ngModelChange)="inputChanged()"/>
    @if (companiesLoading) {
        <i class="fa fa-spinner fa-pulse form-control-feedback"></i>
    }
</div>
